var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.playerOptions,"playsinline":true,"customEventName":"customstatechangedeventname"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }